<div class="modal-letter-request modal">
    <div class="modal-header">
        <h1>{{ 'creditLetter.modalRequest.' + title | translate }}</h1>
        <mat-icon class="close" mat-dialog-close>close</mat-icon>
    </div>

    <div class="inline-vertical-align input-convert-values">
        <div class="inputs-value-container inline-vertical-align">
            <div class="big-value-container">
                <label class="input-label">{{ 'creditLetter.new.valueInMoney' | translate }}</label>
                <input (keydown.ArrowDown)="blockNegativeNumber($event, $event.target.value)" [disabled]="!suggestValue" type="number" class="input big-value" [(ngModel)]="proposedValue" (input)="convertTokens($event.target.value)" placeholder="0,00"
                (keypress)="onKeyPressEvent($event)">
            </div>
            <mat-icon class="swap-icon" fontSet="material-icons-round">swap_horiz</mat-icon>
            <mat-icon class="swap-icon-vert" fontSet="material-icons-round">swap_vert</mat-icon>
            <div class="big-value-container">
                <label class="input-label">{{ 'creditLetter.new.convertedValue' | translate }}</label>
                <input disabled type="text" class="input big-value" [(ngModel)]="tokensAmount">
            </div>
        </div>
        <div class="toggle" *ngIf="title === 'answer'">
            <mat-slide-toggle [(ngModel)]="suggestValue">{{ 'creditLetter.modalRequest.suggestValue' | translate }}</mat-slide-toggle>
        </div>
    </div>

    <div class="message-container">
        <textarea #textarea [(ngModel)]="message" [placeholder]="'creditLetter.modalRequest.optionalMessage' | translate" class="custom-text-area"  maxlength="200"></textarea>
        <p class="counter">{{ textarea?.value?.length }} / 200</p>
    </div>

    <div class="modal-buttons">
        <button class="btn outlined"  mat-dialog-close>{{ 'button.cancel' | translate }}</button>
        <button (click)="confirmOperation()" [disabled]="requestedValueNumber <= 0" *ngIf="title === 'answer'" class="btn default">{{ 'creditLetter.modalRequest.sendNow' | translate }}</button>
        <button (click)="confirmOperation()" *ngIf="title === 'approve'" class="btn default">{{ 'creditLetter.modalRequest.approve' | translate }}</button>
        <button (click)="confirmOperation()" *ngIf="title === 'deny'" class="btn default">{{ 'creditLetter.modalRequest.deny' | translate }}</button>
    </div>

</div>
